import {
  Button,
  chakra,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput, FormSelect } from "../../../../components/Forms";
import { USER_ROLES, VALIDATION_PATTERNS } from "../../../../utils";
import * as React from "react";

function AddExternalUserModal({ isOpen, onClose, onSubmit, roles }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "userManagement.userModal"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onModalClose = () => {
    onClose();
  };

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  return isOpen ? <Modal isOpen={isOpen} onClose={onModalClose} size="md">
    <ModalOverlay />
    <ModalContent>
      <chakra.form onSubmit={handleSubmit(handleFormSubmit)}>
        <ModalHeader>{t("addExternalUser")}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Flex direction="column" gap="2" marginBottom={10}>
            <FormInput
              label={`${t("labels.username")} *`}
              placeholder={t("placeholders.username")}
              type="email"
              errors={errors}
              {...register("username", {
                required: globalTranslation("entityRequired", { entityName: t("labels.username") }),
                pattern: VALIDATION_PATTERNS.EMAIL_ADDRESS
              })}
              maxInlineSize={"var(--chakra-sizes-full)"}
            />
            <FormSelect
              {...register("roleId",
                { required: globalTranslation("entityRequired", { entityName: t("labels.userRole") }) })}
              placeholder={" "}
              label={`${t("labels.userRole")} *`}
              errors={errors}
              maxInlineSize={"var(--chakra-sizes-full)"}
            >
              {roles
                .filter(roleObj => roleObj.role === USER_ROLES.CSRD_MEMBER)
                .map(roleObj => {
                  return <option key={roleObj?.id} value={roleObj?.id}>
                    {globalTranslation(`userManagement.roles.${roleObj?.role}`, { defaultValue: roleObj?.role })}
                  </option>;
                })
              }
            </FormSelect>
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onModalClose}>
            {t("buttons.close")}
          </Button>
          <Button colorScheme="customScheme" type="submit">
            {t("buttons.save")}
          </Button>
        </ModalFooter>
      </chakra.form>
    </ModalContent>
  </Modal> : null;
}

export default AddExternalUserModal;